module.exports = __webpack_public_path__ + "static/media/tu-gestor-fiscal-logo.7432a4d3.png";